// src/components/Error.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import '../App.css';
function Error() {
  return (
    <div className="App">
  <header className="App-header">
    <h1>404 - Page Not Found</h1>
  </header>
  <main className="App-main">
    <div className="center-container">
      <DotLottieReact src="https://lottie.host/31726179-f452-4291-a263-80628f67ee91/BFCF90yDPG.lottie" loop style={{width:'500px',height:'300px'}} autoplay/>
      <div style={{ marginTop: '20px', textAlign: 'center' }}>
        <Link to="/">
          <button className="rounded-button" style={{ padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}>Go to Home</button>
        </Link>
      </div>
    </div>
  </main>
  <footer className="App-footer">
    <Link to="/">Home</Link> | 
    <Link to="/terms">Terms and Conditions</Link> | 
    <Link to="/privacy">Privacy Policy</Link>
  </footer>
</div>

  );
}
function App() {
  
}
export default Error;
